/*
===========================================
Tabs
===========================================
*/
import debounce from 'debounce';
import TinyAnimate from 'TinyAnimate';
import scrollToElement from 'scroll-to-element';
import { on, fire } from 'delegated-events';
import helpers from './helpers.js';

export default (function () {
  let initialLoad = true;
  return {
    init() {
      const allTabs = document.querySelectorAll('.js-tabs');

      const ctrlMarkup = `<div class="tabs__nav-controls">
        <button class="tabs__nav-control tabs__nav-control--left js-tab-left">Left</button>
        <button class="tabs__nav-control tabs__nav-control--right js-tab-right">Right</button>
      </div>`;

      if (allTabs === null) return;

      helpers.forEach(allTabs, (index, tabsSet) => {
        const tabLinks = tabsSet.querySelectorAll('.tabs__nav-link');
        const tabHeaders = tabsSet.querySelectorAll('.tab__header');
        // this.addClose(tabsSet);
        // Set up the click event for the tabs.
        helpers.forEach(tabLinks, (i, val) => {
          const tabLink = val;
          if (helpers.hasClass(tabLink, 'tabs__nav-link--ext')) return;
          tabLink.addEventListener('click', (e) => {
            e.preventDefault();
            this.setActive(tabsSet, tabLinks, tabLink);
          });
        });

        const tabsNav = tabsSet.querySelector('.tabs__nav');

        if (helpers.hasClass(tabsSet, 'tabs--lrg-image')) {
          const tabsList = tabsNav.querySelector('.tabs__nav-list');

          tabsList.insertAdjacentHTML('afterend', ctrlMarkup);

          const track = document.createElement('div');
          track.className = 'tabs__nav-track';
          helpers.wrap(tabsList, track);

          const setWidth = () => {
            const w = track.clientWidth / 4;
            const tabItem = track.querySelectorAll('.tabs__nav-item');
            tabsList.style.cssText = `width: ${tabLinks.length * w}px;`;
            helpers.forEach(tabItem, (i, el) => {
              el.style.cssText = `width: ${w}px;`;
            });
          };

          if (document.querySelectorAll('.ie9').length) {
            window.addEventListener('resize', setWidth);
            setWidth();
          }

          const checkWidth = () => {
            helpers.removeClass(tabsNav, 'has-controls');
            if (track.scrollWidth > track.clientWidth) {
              helpers.addClass(tabsNav, 'has-controls');
            }
          };

          const checkPos = () => {
            const controls = tabsSet.querySelectorAll('.js-tab-right, .js-tab-left');
            const left = tabsSet.querySelectorAll('.js-tab-left');
            const right = tabsSet.querySelectorAll('.js-tab-right');
            const max = track.scrollWidth - track.clientWidth;

            helpers.removeClass(controls, 'is-disabled');

            if (track.scrollLeft === 0) {
              helpers.addClass(left, 'is-disabled');
            }

            if (track.scrollLeft === max) {
              helpers.addClass(right, 'is-disabled');
            }
          };

          checkWidth();
          checkPos();

          window.addEventListener('resize', debounce(() => {
            checkWidth();
            checkPos();
          }, 100, false));

          // TODO Animate the scroll?

          tabsSet.querySelector('.js-tab-right').addEventListener('click', (e) => {
            e.preventDefault();
            const width = tabsNav.querySelector('.tabs__nav-item').offsetWidth;
            // track.scrollLeft += width;

            TinyAnimate.animate(track.scrollLeft, track.scrollLeft + width, 300, (w) => {
              track.scrollLeft = w;
            }, 'linear', checkPos);
          });

          tabsSet.querySelector('.js-tab-left').addEventListener('click', (e) => {
            e.preventDefault();
            const width = tabsNav.querySelector('.tabs__nav-item').offsetWidth;
            TinyAnimate.animate(track.scrollLeft, track.scrollLeft - width, 300, (w) => {
              track.scrollLeft = w;
            }, 'easeOutQuad', checkPos);
            // track.scrollLeft -= width;
            // checkPos();
          });
        }

        if (helpers.breakpoint(tabsSet) !== 'mobile' || tabsSet.getAttribute('data-initial-closed-mob') !== 'true') {
          helpers.triggerEvent(tabLinks[0], 'click');
        }

        if (!helpers.hasClass(tabsSet, 'tabs--lrg-image')) {
          helpers.forEach(tabHeaders, (i, val) => {
            const tabHeader = val;

            tabHeader.addEventListener('click', (e) => {
              e.preventDefault();
              // this.setActive(tabsSet, tabLinks, tabLink);
              const tabId = val.closest('.tab').id;
              const tabLink = e.currentTarget.closest('.is-current') !== null ? null : tabsSet.querySelector(`a[href="#${tabId}"]`);

              this.setActive(tabsSet, tabLinks, tabLink);
            });
          });
        }
      });
      initialLoad = false;
    },
    addClose(tabsSet) {
      const tabs = tabsSet.querySelectorAll('.tab');
      const tabLinks = tabsSet.querySelectorAll('.tabs__nav-link');
      helpers.forEach(tabs, (i, element) => {
        element.insertAdjacentHTML('afterbegin', '<a href="#" class="tab__close js-close-tab">Close</a>');
        const closeBtn = element.querySelector('.js-close-tab');
        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          helpers.removeClass(tabLinks, 'is-active');
          helpers.removeClass(tabs, 'is-current');
        });
      });
    },
    setActive(tabsSet, tabLinks, tabLink) {
      const tabs = tabsSet.querySelectorAll('.tab');
      helpers.removeClass(tabLinks, 'is-active');
      helpers.removeClass(tabs, 'is-current');
      if (tabLink !== null && tabLink !== undefined) {
        const target = tabLink.getAttribute('href');
        const activeTab = document.querySelector(target);
        helpers.addClass(tabLink, 'is-active');
        helpers.addClass(activeTab, 'is-current');

        const tabImg = activeTab.getAttribute('data-tab-img');
        const tabImgTarg = tabsSet.querySelector('.tabs__img');
        if (tabImg !== null && tabImgTarg !== null) {
          tabImgTarg.style.cssText = `background-image: url('${tabImg}')`;
        }

        // Scroll to the tab header on mobile
        const tabHeader = activeTab.querySelector('.tab__header');
        if (!initialLoad && tabLink.closest('.js-tabs') !== null && tabLink.closest('.js-tabs').getAttribute('data-scroll') === 'true') {
          scrollToElement(tabHeader, {
            duration: 500,
            ease: 'in-out-quad',
          });
        }
      }

      fire(window, 'resize');
    },
  };
}());
